<template>
  <div class="cat-edit-page" dir="rtl">
    <header class="cat-edit-top">
      <div>
        <p class="cat-edit-top__eyebrow">
          مدیریت دسته‌بندی‌ها
          <template v-if="pathText"> · {{ pathText }}</template>
        </p>
        <h1 class="cat-edit-top__title">{{ category ? `ویرایش «${category.name}»` : 'ویرایش دسته‌بندی' }}</h1>
      </div>
      <div class="cat-edit-top__actions">
        <router-link v-if="category && category.slug" class="cat-edit-chip"
                     :to="{ name: 'SingleCategory', params: { slug: category.slug } }">
          <b-icon icon="box-seam"/> محصولات: {{ formatNumber(category.products_count || 0) }}
        </router-link>
        <router-link :to="{ name: 'Category' }" class="cat-edit-chip">
          بازگشت به دسته‌بندی‌ها <b-icon icon="arrow-left"/>
        </router-link>
      </div>
    </header>

    <div v-if="loading" class="cat-edit-state">
      <div class="spinner-border" role="status"></div>
      <p class="mb-0">در حال بارگذاری...</p>
    </div>

    <div v-else-if="!category" class="cat-edit-state">
      <b-icon icon="exclamation-circle" class="cat-edit-state__icon"/>
      <p class="mb-2">این دسته پیدا نشد (ممکن است حذف شده یا در زبان دیگری باشد).</p>
      <router-link :to="{ name: 'Category' }" class="cat-edit-chip cat-edit-chip--dark">
        بازگشت به دسته‌بندی‌ها <b-icon icon="arrow-left"/>
      </router-link>
    </div>

    <category-form v-else layout="page" :category="category" :records="records" :tree="tree"
                   @saved="onSaved" @image-removed="onImageRemoved" @add-translation="onAddTranslation"/>
  </div>
</template>

<script>
import CategoryForm from "../../components/dashboard/category/CategoryForm.vue";
import {
  buildCategoryTree,
  categoryKey,
  categoryPathNames,
  normalizeCategories
} from "../../components/dashboard/category/categoryTree";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "EditCategory",
  components: {CategoryForm},
  data() {
    return {
      loading: true,
      records: Object.freeze([]),
    }
  },
  computed: {
    tree() {
      return buildCategoryTree(this.records)
    },
    node() {
      return this.tree.byId.get(categoryKey(this.$route.params.id)) || null
    },
    category() {
      return this.node ? this.node.data : null
    },
    pathText() {
      return this.node ? categoryPathNames(this.node).join(' › ') : ''
    },
  },
  watch: {
    '$route.params.id'() {
      if (!this.records.length) this.load()
    }
  },
  methods: {
    formatNumber,
    async load() {
      this.loading = true
      try {
        this.$store.commit("Category/setFilters", {key: "search", value: ''});
        const res = await this.$store.dispatch("Category/getDashboardCategoriesWithoutState")
        this.records = Object.freeze(normalizeCategories((res && res.data && res.data.data) || []))
      } catch (e) {
        console.log(e)
        this.records = Object.freeze([])
      } finally {
        this.loading = false
      }
    },
    // update the local record in place (no reload / refetch)
    upsert(record) {
      const key = categoryKey(record.id)
      const list = this.records.slice()
      const index = list.findIndex(item => categoryKey(item.id) === key)
      if (index > -1) list.splice(index, 1, {...list[index], ...record})
      else list.push(record)
      this.records = Object.freeze(list)
    },
    onSaved(record) {
      this.upsert(record)
    },
    onImageRemoved(category) {
      if (category) this.upsert({id: category.id, image: null})
    },
    onAddTranslation(defaults) {
      const query = {create: 1, lang: defaults.language_id, name: defaults.name || undefined}
      if (defaults.description) query.description = defaults.description
      this.$router.push({name: 'Category', query})
    },
  },
  mounted() {
    this.load()
  },
}
</script>

<style scoped>
.cat-edit-page {
  padding: 8px 4px 24px;
}

.cat-edit-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
  padding: 1.1rem 1.4rem;
  border-radius: 20px;
  background: linear-gradient(135deg, #1e1e1e 0%, #3a3a3a 55%, #eb3d60 140%);
  color: #fff;
}

.cat-edit-top__eyebrow {
  margin: 0 0 0.2rem;
  font-size: 0.8rem;
  opacity: 0.8;
}

.cat-edit-top__title {
  margin: 0;
  font-size: 1.45rem;
  font-weight: 800;
}

.cat-edit-top__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.cat-edit-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.45rem 0.95rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
  font-weight: 700;
  font-size: 0.85rem;
  text-decoration: none;
}

.cat-edit-chip:hover {
  background: rgba(255, 255, 255, 0.24);
  color: #fff;
  text-decoration: none;
}

.cat-edit-chip--dark {
  background: #1e1e1e;
}

.cat-edit-chip--dark:hover {
  background: #eb3d60;
}

.cat-edit-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.6rem;
  padding: 3rem 1rem;
  border: 1px solid rgba(30, 30, 30, 0.08);
  border-radius: 18px;
  background: #fff;
  color: #6b7280;
}

.cat-edit-state__icon {
  font-size: 2rem;
  color: #eb3d60;
}
</style>
